var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-away"},[_c('div',{staticClass:"live-away-title"},[_vm._v(_vm._s(_vm.roomInfo.title))]),_c('div',{staticClass:"live-away-txt"},[_vm._v("主播暂时不在，请稍等片刻~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }